import { call, put, takeLatest } from "redux-saga/effects";

import { callOrderCodeGetApi } from "../Context/getOrderCodeApi";
import {
  onGetOrderCode,
  onGetOrderCodeError,
  onGetOrderCodeSuccess,
} from "../Store/Slices/getOrderCodeSlice";

function* GetOrderCode({ payload }) {
  try {
    const getOrderCodeResponse = yield call(callOrderCodeGetApi, payload);
    if (getOrderCodeResponse.httpStatusCode === "200") {
      yield put(
        onGetOrderCodeSuccess({
          getData: getOrderCodeResponse.response,
          message: getOrderCodeResponse.errorMessage,
          status_code: getOrderCodeResponse.httpStatusCode,
        })
      );
    } else {
      yield put(
        onGetOrderCodeError({
          getData: getOrderCodeResponse.response,
          message: getOrderCodeResponse.errorMessage,
          status_code: getOrderCodeResponse.httpStatusCode,
        })
      );
    }
  } catch (error) {
    const message =
      error.response.data.responseMessage || "Something went wrong";
    yield put(onGetOrderCodeError({ data: [], message, status_code: 400 }));
  }
}
export default function* OrderCodeSaga() {
  yield takeLatest(onGetOrderCode.type, GetOrderCode);
}
